import React from 'react';

import { TagsTable } from '../components/TagsTable/TagsTable';
import { useUsers } from '../hooks/useUsers';
import { useTagsEnrichments } from '../hooks/useTagsEnrichments';

import type { FC } from 'react';

export const Tags: FC = () => {
  const { data: users = [] } = useUsers();

  const { data: enrichments = [], isLoading } = useTagsEnrichments();

  return (
    <TagsTable users={users} enrichments={enrichments} loading={isLoading} />
  );
};
